// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"8e130019","759":"030277e0"}[chunkId] + ".chunk.css";
};